<template>
    <div id="Company" class="starter-template">
        <b-container>
            <b-row>
                <b-col cols="3">
                    {{$t('COM_NAME')}}:<br>
                </b-col>
                <b-col cols="9">
                    {{ company.companyName }}
                </b-col>
            </b-row>
            <b-row>
                <b-col cols="3">
                    {{this.$t('ADDRS_OF')}}:<br>
                </b-col>
                <b-col cols="9">
                    {{ company.address }}
                </b-col>
            </b-row>
            <b-row>
                <b-col cols="3">
                    {{this.$t('PHONES')}}:<br>
                </b-col>
                <b-col cols="9">
                    {{ company.phones }}
                </b-col>
            </b-row>
            <b-row>
                <b-col cols="3">
                    {{this.$t('URL_HOME')}}:<br>
                </b-col>
                <b-col cols="9">
                    {{ company.homeUrl }}
                </b-col>
            </b-row>
            <b-row>
                <b-col cols="3">
                    {{this.$t('URL_BOOK')}}:<br>
                </b-col>
                <b-col cols="9">
                    {{ company.bookUrl }}
                </b-col>
            </b-row>
            <b-row>
                <b-col cols="3">
                    Email:<br>
                </b-col>
                <b-col cols="9">
                    {{ company.email }}
                </b-col>
            </b-row>
            <b-row>
                <b-col cols="3">
                    {{this.$t('OTHER')}}:<br>
                </b-col>
                <b-col cols="9">
                    {{ company.other }}
                </b-col>
            </b-row>
            <b-row>
                <b-col cols="3">
                    {{this.$t('USER')}}:<br>
                </b-col>
                <b-col cols="9">
                    {{ company.userName }}
                </b-col>
            </b-row>

        </b-container>

    </div>
</template>

<script>
import { BContainer, BRow, BCol } from 'bootstrap-vue';

export default {
  name: 'Company',
  components: {
    BContainer, BRow, BCol
  },
  data: function() {
    return {
      act: '/getCompany',
      company: {},
      intLoc: this.$i18n.locale,
      resLoc: '',
      myKey: 0,
    }
  },
  metaInfo() {
    return {
        title: this.company.companyName,
        meta: [
          { vmid: 'description', name: 'description', content: this.company.companyName },
        ],
        link: [
            { rel: 'canonical', href: location.href }
        ]
    }
  },
  beforeMount() {
    this.curUserName = this.$store.state.curUserName;
    this.companyName = this.$rmEncHyp(this.$route.params.itemName);
    this.getCompany();
  },
  methods: {
    async getCompany() {
        try {
            const response = await this.$http.get(this.act, {
                params: {
                    companyName: this.companyName,
                    intLoc: this.intLoc
                }
            });
            this.company = response.data;

        }
        catch(error) {
            if(typeof error.response === 'undefined') this.$serveErr('Company: getCompany() '+error.message);
            else {
                this.$showErr(error.response.data, error.response.status);
                this.$router.push('/');
            }
        }
    },
    descMeta() {
        let attrs;
        let meta;
        if(this.trip.intLoc == 'en') {
            meta = 'Company data card ';
        } else {
            meta = 'Информационная карта компании ';
        }
        meta = meta + this.companyName;
        let refs = false;
        if(this.trip.countries.length>0) {
            refs = true;
            for(let i=0; i<this.company.countries.length; i++ )
                meta = meta + ', ' + this.trip.countries[i];
        }
        if(this.trip.districts)
        for(let i=0; i<this.company.districts.length; i++ )
            meta = meta + ', ' + this.trip.districts[i];
        if(this.trip.cities)
        for(let i=0; i<this.company.cities.length; i++ )
            meta = meta + ', ' + this.trip.cities[i];
        if(refs) meta = meta + ', ' + attrs;
        console.log(meta);
    },
  },
  computed: {
  }

}

</script>

<style>
/*
h4{
    color: blue;
}
*/
</style>